<div class="d-flex flex-row">
  <div style="position: fixed; z-index: 1;">
    <app-dashboard-side-menu></app-dashboard-side-menu>
  </div>
  <div class="p-content d-flex flex-column w-100" style="margin-left: 217px;">
    <app-dashboard-top-menu></app-dashboard-top-menu>
    @if (loading) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    } @else {
      <div class="template-content">
        <!-- Adicionar Produto -->
        <div class="w-100" style="display: flex; align-items: end; justify-content: space-between;">
          <!-- Adicionar por referencia -->
          <div style="width: 100%; margin-right: 50px;">
            <app-chips-add-products (chipsChanged)="updateChips($event)"></app-chips-add-products>
          </div>
          <!-- Adicionar por laboratorio -->
          <div class="select">
            <!-- <p>Escolher Laboratório</p> -->
            <mat-form-field>
              <mat-select [(ngModel)]="labs"
                multiple
                (ngModelChange)="onLabChange($event)"
                placeholder="Por laboratorio...">
                <mat-select-trigger>
                  {{ getSelectedLabLabel() }}
                </mat-select-trigger>
                <mat-option [value]="'0'">
                  Todas
                </mat-option>
                <!-- Lista de laboratorios  -->
                @for (lab of laboratories; track lab) {
                  <mat-option [value]="lab.id">
                    {{lab.labName}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Escolher loja a comparar -->
          <div class="select">
            <p>Escolher loja a pesquisar</p>
            <mat-form-field>
              <mat-select [(ngModel)]="stores"
                multiple
                (ngModelChange)="onStoreChange($event)">
                <mat-select-trigger>
                  {{ getSelectedStoresLabel() }}
                </mat-select-trigger>
                <mat-option [value]="0">
                  Todas
                </mat-option>
                <!-- Lista de concorrentes  -->
                @for (competitor of competitors; track competitor) {
                  <mat-option [value]="competitor.idConcorrente">
                    {{competitor.nomeConcorrente}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div style="bottom: 0; align-items: center;">
            <button (click)="addProductToComparator()" class="adicionar-produto">
              Adicionar
              <mat-icon class="add-icon">add</mat-icon>
            </button>
          </div>
        </div>
        <mat-divider style="margin-top: 25px;"></mat-divider>
        <!-- Filtrar Dados  -->
        <div class="w-100" style="margin-top: 25px; margin-bottom: 25px; display: flex; align-items: end;">
          <div style="width:73%; float: left; margin-right: 50px;">
            <p>Procurar produto por referência ou nome</p>
            <mat-form-field style="width: 100%;">
              <input matInput [formControl]="searchControl" placeholder="Ex. 000001 ou lasix">
            </mat-form-field>
          </div>
          <div style="float: left; width: 24%;">
            <p>Escolher loja a pesquisar</p>
            <mat-form-field style="width: 100%;">
              <mat-select [(ngModel)]="storesFilter"
                multiple
                (ngModelChange)="onStoreChangeFilter($event)">
                <mat-select-trigger>
                  {{ getSelectedStoresLabelFilter() }}
                </mat-select-trigger>
                <mat-option [value]="0">
                  Todas
                </mat-option>
                @for (competitor of competitors; track competitor) {
                  <mat-option [value]="competitor.idConcorrente">
                    {{competitor.nomeConcorrente}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="bottom: 0; align-items: center; margin-bottom: 25px; float: right">
          <button (click)="downloadFile()" class="adicionar-produto">
            <span>Exportar csv</span>
            <img src="../../../../assets/Icons/down.png" alt="Download">
          </button>
        </div>
        <!-- Tabela -->
        <div class="w-100 d-flex flex-column justify-content-start">
          <table>
            <thead>
              <tr style="border-radius: 10px !important; text-align: left;">
                <th>
                  <div class="d-flex flex-row" style="align-items: center; justify-content: space-between;">
                    <span>Produto Bio2</span>
                    <div class="d-flex flex-row rows" style="gap: 8px;">
                      <img src="../../../../assets/Icons/arrow-up.png" alt="top-row" class="arrows" (click)="sortTable('NomeProdutoBio2','asc')">
                      <img src="../../../../assets/Icons/arrow-down.png" alt="down-row" class="arrows" (click)="sortTable('NomeProdutoBio2','desc')">
                    </div>
                  </div>
                </th>
                <th>Preço Bio2</th>
                <th>Produto Concorrente</th>
                <th>Preço Concorrente</th>
                <th>Campanha Concorrente</th>
                <th>Nome Pesquisado</th>
                <th>Concorrente</th>
                <th>
                  <div class="d-flex flex-row" style="align-items: center; justify-content: space-between;">
                    <span>Data Adicionado</span>
                    <div class="d-flex flex-row rows" style="gap: 8px;">
                      <img src="../../../../assets/Icons/arrow-up.png" alt="top-row" class="arrows" (click)="sortTable('DataAdicionado', 'asc')">
                      <img src="../../../../assets/Icons/arrow-down.png" alt="down-row" class="arrows" (click)="sortTable('DataAdicionado', 'desc')">
                    </div>
                  </div>
                </th>
                <th>
                  <div class="d-flex flex-row" style="align-items: center; justify-content: space-between;">
                    <span>Data de Análise</span>
                    <div class="d-flex flex-row rows" style="gap: 8px;">
                      <img src="../../../../assets/Icons/arrow-up.png" alt="top-row" class="arrows" (click)="sortTable('DataAnalise', 'asc')">
                      <img src="../../../../assets/Icons/arrow-down.png" alt="down-row" class="arrows" (click)="sortTable('DataAnalise', 'desc')">
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (productComparator of productsComparatorDisplay; track productComparator; let i = $index) {
                <tr>
                  <td class="productName" (click)="openModal(productComparator)">{{productComparator.nomeProdutoBio2}}</td>
                  <td>{{productComparator.precoBio2}} €</td>
                  <td>{{productComparator.produtoConcorrente}}</td>
                  <td>{{productComparator.precoConcorrente}} €</td>
                  <td>{{productComparator.campanhaConcorrente}}</td>
                  <td>{{productComparator.nomePesquisa}}</td>
                  <td>{{productComparator.nomeConcorrente}}</td>
                  <td>{{productComparator.dataAdicionado | date: 'dd/MM/yyyy'}}</td>
                  <td>{{productComparator.dataAnalise | date: 'dd/MM/yyyy'}}</td>
                </tr>
              }
            </tbody>
          </table>
          <div>
            <mat-paginator #comparatorListPaginator
              [hidden]="productsComparator.data.length <= 0"
              [pageSize]="comparatorPageSize"
              [pageSizeOptions]="comparatorPageSizeOptions"
              [length]="apiResponse"
              (page)="pageProductComparatorChanged($event)"
              showFirstLastButtons
              style="background-color: transparent;">
            </mat-paginator>
          </div>
        </div>
      </div>
    }
    <app-footer></app-footer>
  </div>
</div>